'use client';
import React, { useEffect, useState } from 'react';
import Modal from 'react-modal';

const ConsentModal = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);

    if (typeof window !== 'undefined') {
      Modal.setAppElement('#app-root');
    }

    const consentStatus = localStorage.getItem('userConsent');

    if (!consentStatus) {
      const timer = setTimeout(() => {
        setIsOpen(true);
      }, 500);

      return () => clearTimeout(timer);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('userConsent', 'accepted');
    localStorage.setItem('consentTimestamp', new Date().toISOString());
    setIsOpen(false);
  };

  const handleReject = () => {
    localStorage.setItem('userConsent', 'rejected');
    localStorage.setItem('consentTimestamp', new Date().toISOString());
    setIsOpen(false);
  };

  if (!isClient) {
    return null;
  }

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={() => {}}
      shouldCloseOnOverlayClick={false}
      shouldCloseOnEsc={false}
      ariaHideApp={false}
      aria-labelledby="consent-modal-title"
      aria-describedby="consent-modal-description"
      role="dialog"
      className="fixed bottom-6 left-6 w-[90%] max-w-[420px] rounded-2xl bg-white p-6 shadow-2xl outline-none md:p-8"
      overlayClassName="fixed inset-0 bg-transparent z-[9999] pointer-events-none"
      style={{
        content: {
          pointerEvents: 'auto',
        },
      }}
    >
      <div className="flex flex-col gap-6">
        {/* Header */}
        <div className="flex items-center gap-3">
          <div className="flex h-12 w-12 items-center justify-center rounded-full bg-blue-100">
            <svg
              className="h-6 w-6 text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
              />
            </svg>
          </div>
          <h2
            id="consent-modal-title"
            className="font-opt text-xl font-semibold text-primary md:text-2xl"
          >
            We Value Your Privacy
          </h2>
        </div>

        {/* Content */}
        <div className="flex flex-col gap-4">
          <p
            id="consent-modal-description"
            className="text-gray-700 font-opt text-sm leading-relaxed md:text-base"
          >
            We use cookies to enhance your experience, analyze site traffic, and
            personalize content. By clicking &#34;Accept All&#34;, you consent
            to our use of cookies.
          </p>
          <p className="text-gray-600 font-opt text-xs md:text-sm">
            You can change your preferences at any time in your browser
            settings.
          </p>
        </div>

        {/* Buttons */}
        <div className="flex flex-col gap-3 sm:flex-row">
          <button
            onClick={handleAccept}
            className="flex-1 rounded-full border border-transparent bg-lightBlue px-6 py-3 font-opt text-sm font-medium text-white transition-all duration-300 hover:border-lightBlue hover:bg-transparent hover:text-lightBlue hover:shadow-lg md:text-base"
          >
            Accept All
          </button>
          <button
            onClick={handleReject}
            className="border-gray-600 text-gray-700 flex-1 rounded-full border bg-transparent px-6 py-3 font-opt text-sm font-medium transition-all duration-300 hover:border-transparent hover:bg-lightBlue hover:text-white hover:shadow-lg md:text-base"
          >
            Reject All
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ConsentModal;
